import { render, staticRenderFns } from "./todo-section.vue?vue&type=template&id=c9acfd0a&lang=pug&"
import script from "./todo-section.vue?vue&type=script&lang=js&"
export * from "./todo-section.vue?vue&type=script&lang=js&"
import style0 from "./todo-section.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports